const ToolPluginActions = {
  CREATED: "tool-plugin/created",
  LOADED: "tool-plugin/loaded",
  UPDATED: "tool-plugin/updated",
  LIST_LOADED: "tool-plugins/loaded",
  LIST_CHANGED: "tool-plugins/changed",
  SETTINGS_LOADED: "tool-plugin/settings/loaded",
  SETTINGS_CHANGED: "tool-plugin/settings/changed",
};

export default ToolPluginActions;
